import { COMPARE_PRESET_LABELS, type ComparePreset } from '../../lib/comparePeriod';

const POINT_IN_TIME_PRESETS: ComparePreset[] = [
  'none',
  'last_month',
  'last_quarter',
  'last_year',
];

const RANGE_PRESETS: ComparePreset[] = [
  'none',
  'prior_period',
  'last_month',
  'last_quarter',
  'last_year',
  'ytd_last_year',
  'ttm',
];

/**
 * Compare-to dropdown for any report. `mode` controls which presets are shown:
 *   - point_in_time (Balance Sheet) — skips period-length presets like TTM.
 *   - range (Income Statement / Cash Flow) — full preset list.
 */
export function ComparePicker({
  value,
  onChange,
  mode,
}: {
  value: ComparePreset;
  onChange: (next: ComparePreset) => void;
  mode: 'point_in_time' | 'range';
}) {
  const opts = mode === 'point_in_time' ? POINT_IN_TIME_PRESETS : RANGE_PRESETS;
  return (
    <label style={{ fontSize: 13, display: 'inline-flex', alignItems: 'center', gap: 6 }}>
      Compare to:
      <select value={value} onChange={(e) => onChange(e.target.value as ComparePreset)}>
        {opts.map((p) => (
          <option key={p} value={p}>
            {COMPARE_PRESET_LABELS[p]}
          </option>
        ))}
      </select>
    </label>
  );
}
